import React, { useState } from "react";
import { CompanyAdminLayout } from "../../components/CompanyAdmin/CompanyAdminLayout";
import TextInput from "../../components/UI/TextInput";
import Table from "../../components/UI/Table";
import { Button } from "../../components/UI/Button";
import Selection from "../../components/UI/Selection";
import Modal from "../../components/UI/Modal";

const RefundManagement: React.FC = () => {
  const [searchKeyword, setSearchKeyword] = useState("");

  interface Refund {
    refundStatus:
      | "REQUESTED"
      | "APPROVED"
      | "REJECTED"
      | "IN_TRANSIT"
      | "RECEIVED"
      | "INSPECTION"
      | "COMPLETED"
      | "CANCELLED";
    createdAt: string;
    id: number;
    orderId: number;

    customerName: string;
    orderedAt: string;

    refundReason: string;
    refundReasonDetail: string;

    paymentAmount: string;
  }

  const loadFromLocalStorage = () => {
    let taxReceiptOrders = localStorage.getItem("MOCK_refunds");
    if (taxReceiptOrders) {
      return JSON.parse(taxReceiptOrders) as Refund[];
    } else {
      saveToLocalStorage(
        JSON.parse(`
[
  {
    "id": 47291,
    "refundStatus": "REQUESTED",
    "createdAt": "2026-02-15T09:12:00",
    "orderId": 10001,
    "customerName": "김민수",
    "orderedAt": "2026-02-10T14:21:00",
    "refundReason": "단순 변심",
    "refundReasonDetail": "색상이 생각과 다릅니다.",
    "paymentAmount": "45000",
    "isProcessed": false
  },
  {
    "id": 83915,
    "refundStatus": "APPROVED",
    "createdAt": "2026-02-14T11:30:00",
    "orderId": 10002,
    "customerName": "이서연",
    "orderedAt": "2026-02-09T16:45:00",
    "refundReason": "상품 불량",
    "refundReasonDetail": "제품에 스크래치가 있습니다.",
    "paymentAmount": "78000",
    "isProcessed": true
  },
  {
    "id": 16428,
    "refundStatus": "IN_TRANSIT",
    "createdAt": "2026-02-13T15:05:00",
    "orderId": 10003,
    "customerName": "박지훈",
    "orderedAt": "2026-02-08T10:12:00",
    "refundReason": "배송 지연",
    "refundReasonDetail": "예상 배송일보다 5일 지연되었습니다.",
    "paymentAmount": "32000",
    "isProcessed": false
  },
  {
    "id": 90733,
    "refundStatus": "INSPECTION",
    "createdAt": "2026-02-12T13:40:00",
    "orderId": 10004,
    "customerName": "최유진",
    "orderedAt": "2026-02-07T18:25:00",
    "refundReason": "오배송",
    "refundReasonDetail": "주문한 상품과 다른 제품이 도착했습니다.",
    "paymentAmount": "99000",
    "isProcessed": true
  },
  {
    "id": 55102,
    "refundStatus": "COMPLETED",
    "createdAt": "2026-02-11T09:55:00",
    "orderId": 10005,
    "customerName": "정하늘",
    "orderedAt": "2026-02-06T12:10:00",
    "refundReason": "상품 파손",
    "refundReasonDetail": "포장이 훼손되어 내부 상품이 파손되었습니다.",
    "paymentAmount": "61000",
    "isProcessed": true
  },
  {
    "id": 72384,
    "refundStatus": "REJECTED",
    "createdAt": "2026-02-10T17:20:00",
    "orderId": 10006,
    "customerName": "한지민",
    "orderedAt": "2026-02-05T09:00:00",
    "refundReason": "사용 흔적 있음",
    "refundReasonDetail": "제품 사용 후 반품 요청",
    "paymentAmount": "54000",
    "isProcessed": false
  },
  {
    "id": 31876,
    "refundStatus": "CANCELLED",
    "createdAt": "2026-02-09T08:45:00",
    "orderId": 10007,
    "customerName": "오준호",
    "orderedAt": "2026-02-04T11:35:00",
    "refundReason": "고객 취소",
    "refundReasonDetail": "반품 요청 철회",
    "paymentAmount": "27000",
    "isProcessed": false
  },
  {
    "id": 69451,
    "refundStatus": "RECEIVED",
    "createdAt": "2026-02-08T14:10:00",
    "orderId": 10008,
    "customerName": "윤아름",
    "orderedAt": "2026-02-03T15:50:00",
    "refundReason": "사이즈 미스",
    "refundReasonDetail": "사이즈가 맞지 않습니다.",
    "paymentAmount": "83000",
    "isProcessed": true
  }
]
`),
      );

      taxReceiptOrders = localStorage.getItem("MOCK_refunds");

      if (!taxReceiptOrders) throw new Error("MOCK_refunds is null");
      return JSON.parse(taxReceiptOrders) as Refund[];
    }
  };

  const saveToLocalStorage = (fontList: Refund[]) => {
    localStorage.setItem("MOCK_refunds", JSON.stringify(fontList));
    return fontList;
  };

  const [loadedData, setLoadedData] = useState<Refund[]>(
    loadFromLocalStorage(),
  );

  const loadData = () => {
    setLoadedData(loadFromLocalStorage());
  };

  const [selectedOptions, setSelectedOptions] = useState<
    Record<number, string>
  >([]);

  const [viewingRefund, setViewingRefund] = useState<Refund | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      {isModalVisible && (
        <Modal setIsModalVisible={setIsModalVisible} title={"상세 정보"}>
          <div className="w-[calc(100vw-20vw)] max-w-[31.875rem] mb-3" />

          <div className="grid grid-col-1 sm:grid-cols-2 gap-4">
            <div className="flex flex-col items-start">
              <div className="text-sm text-gray-400">반품 상태</div>
              {(() => {
                switch (viewingRefund?.refundStatus) {
                  case "REQUESTED":
                    return "반품 접수";
                  case "APPROVED":
                    return "승인 완료";
                  case "REJECTED":
                    return "반려";
                  case "IN_TRANSIT":
                    return "회수 중";
                  case "RECEIVED":
                    return "입고 완료";
                  case "INSPECTION":
                    return "품질 검사 중";
                  case "COMPLETED":
                    return "완료";
                  case "CANCELLED":
                    return "취소";
                  default:
                    return "-";
                }
              })()}
            </div>
            <div className="flex flex-col items-start ">
              <div className="text-sm text-gray-400">반품 금액</div>₩
              {viewingRefund?.paymentAmount}
            </div>
            <div className="flex flex-col items-start">
              <div className="text-sm text-gray-400">반품번호</div>
              REFUND-{viewingRefund?.id}
            </div>
            <div className="flex flex-col items-start">
              <div className="text-sm text-gray-400">반품 요청일</div>
              {viewingRefund?.createdAt &&
                new Date(viewingRefund?.createdAt).toISOString().slice(0, 10)}
            </div>
            <div className="flex flex-col items-start">
              <div className="text-sm text-gray-400">주문번호</div>
              ORDER-{viewingRefund?.orderId}
            </div>
            <div className="flex flex-col items-start">
              <div className="text-sm text-gray-400">주문일</div>
              {viewingRefund?.orderedAt &&
                new Date(viewingRefund?.orderedAt).toISOString().slice(0, 10)}
            </div>
            <div className="flex flex-col items-start">
              <div className="text-sm text-gray-400">주문자 이름</div>
              {viewingRefund?.customerName}
            </div>
            <div className="flex flex-col items-start">
              <div className="text-sm text-gray-400">반품 사유</div>
              {viewingRefund?.refundReason}
            </div>
          </div>
          <div className="mt-4 p-3 bg-gray-100 rounded-lg"><div className="text-gray-400">반품 상세 사유:</div><div className="">{viewingRefund?.refundReasonDetail}</div></div>
        </Modal>
      )}

      <CompanyAdminLayout>
        <div className="p-5">
          <div className="mb-[28px] / flex flex-row justify-between gap-[0.5rem]">
            <h2 className="text-[1.375rem] / font-semibold">반품 관리</h2>
          </div>

          <div
            className="mb-[1.25rem] / p-[1.25rem]
          / border border-[#d9d9d9] / rounded-[0.625rem] / bg-white
          / flex flex-col md:flex-row gap-[0.75rem] / justify-stretch"
          >
            <TextInput
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              className="w-full"
              placeholder="주문자 이름으로 검색"
            />
          </div>
          <div className="text-[12px]">
            <Table
              columnWidths={["130px", "160px", "130px", "130px", "150px"]}
              tabledata={{
                head: [
                  <>반품번호</>,
                  <>반품 상태</>,
                  <>반품 접수일시</>,
                  <>반품금액</>,
                  <>관리</>,
                ],
                body: loadedData
                  .filter((item) => {
                    if (searchKeyword === "") return true;

                    return item.customerName
                      .toLowerCase()
                      .includes(searchKeyword.toLowerCase());
                  })
                  .map((item) => [
                    <>REFUND-{item.id}</>,
                    <>
                      <div className="h-[43px]">
                        <Selection
                          selectedOption={(() => {
                            if (!selectedOptions[item.id]) {
                              selectedOptions[item.id] = item.refundStatus;
                            }
                            return (selectedOptions[item.id] =
                              item.refundStatus);
                          })()}
                          // 2. 콜백 함수 형태로 전달하여 value를 인자로 받음
                          setSelectedOption={(newValue) => {
                            // B. 실제 데이터 업데이트 및 로컬 스토리지 저장
                            const updatedData = loadedData.map((dataItem) =>
                              dataItem.id === item.id
                                ? {
                                    ...dataItem,
                                    refundStatus:
                                      newValue as Refund["refundStatus"],
                                  }
                                : dataItem,
                            );

                            saveToLocalStorage(updatedData);
                            setLoadedData(updatedData);

                            return {
                              ...selectedOptions,
                              [item.id]: newValue,
                            };
                          }}
                          options={[
                            { value: "REQUESTED", name: "반품 접수" },
                            { value: "APPROVED", name: "승인 완료" },
                            { value: "REJECTED", name: "반려" },
                            { value: "IN_TRANSIT", name: "회수 중" },
                            { value: "RECEIVED", name: "입고 완료" },
                            { value: "INSPECTION", name: "품질 검사 중" },
                            { value: "COMPLETED", name: "완료" },
                            { value: "CANCELLED", name: "취소" },
                          ]}
                        />
                      </div>
                    </>,
                    <>{new Date(item.createdAt).toISOString().slice(0, 10)}</>,
                    <>₩{item.paymentAmount}</>,
                    <div className="flex flex-row gap-[6px]">
                      <Button
                        onClick={() => {
                          setViewingRefund(item);
                          setIsModalVisible(true);
                        }}
                      >
                        상세 정보
                      </Button>
                    </div>,
                  ]),
              }}
            />
          </div>
        </div>
      </CompanyAdminLayout>
    </>
  );
};

export default RefundManagement;
